<template>
  <q-tab-pane name="subscription">
    <p class="q-mb-none">{{ $t("subscriptions_moved") }}</p>
    <a :href="betaLink" class="primary-link">{{ $t("goto_new_version") }}</a>
  </q-tab-pane>
</template>

<script>
  import { general } from 'src/config'

  export default {
    computed: {
      betaLink () {
        return general.beta_link
      }
    }
  }
</script>
